import { render } from "./NumberThreeIcon.vue?vue&type=template&id=c9cbcb60"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/NumberThreeIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9cbcb60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9cbcb60', __exports__)) {
    api.reload('c9cbcb60', __exports__)
  }
  
  module.hot.accept("./NumberThreeIcon.vue?vue&type=template&id=c9cbcb60", () => {
    api.rerender('c9cbcb60', render)
  })

}


export default __exports__